import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
// components
import Grid from '@mui/material/Grid2'
import { ReduxEntitySelect } from 'components/FormElements'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// graphql
import { OWNED_BY_SELECT_QUERY } from 'graphql/plan/queries'
import { PLAN_TYPES_SELECT_QUERY } from 'graphql/planType/queries'
// utils
import { userAndPositionProps, planTypeProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const Wrapper = styled((props) => <Grid {...props} />)`
  && {
    margin: 0;
    padding: 16px;
    width: inherit;

    & > :last-child {
      margin: 8px 8px 0 auto;
      width: fit-content;
    }
  }
`

// types
interface IIncomingProps {
  clearFilter: () => void
  handleSelectChange: () => void
}

const RegistersFilter: React.FC<IIncomingProps> = ({ clearFilter, handleSelectChange }) => {
  const router = useRouter()

  const isPlansRegister = router?.pathname.includes('/plans')

  return (
    <Wrapper container spacing={2} direction={'column'} wrap={'nowrap'}>
      {isPlansRegister && (
        <Grid>
          <ReduxEntitySelect
            isMultiple
            label={'Plan Type'}
            name={isPlansRegister ? 'planTypeIds' : 'planTypes'}
            onSelectChange={handleSelectChange}
            query={PLAN_TYPES_SELECT_QUERY}
            {...planTypeProps}
          />
        </Grid>
      )}
      <Grid>
        <ReduxEntitySelect
          isMultiple
          label={'Owned By'}
          name={isPlansRegister ? 'ownerIds' : 'ownedByIds'}
          onSelectChange={handleSelectChange}
          query={OWNED_BY_SELECT_QUERY}
          {...userAndPositionProps}
        />
      </Grid>
      <Button type={'button'} layout={BUTTON_LAYOUTS.GRAY} onClick={clearFilter}>
        Clear
      </Button>
    </Wrapper>
  )
}

export default RegistersFilter
